import React, { Component } from 'react';
import styled from 'styled-components';
import { StaticQuery, graphql } from 'gatsby';
import axios from 'axios';
import { reduce, isEmpty } from 'lodash';

import { P } from '../styles/typography';

import Layout from '../components/layout';
import SEO from '../components/seo';
import Title from '../components/Template/Title';
import Container from '../components/Container/Container';
import { Wrapper } from '../components/Container/Wrapper';
import InputGroup from '../components/Input/InputGroup';
import InputText from '../components/Input/InputText/InputText';
import InputTextArea from '../components/Input/InputTextArea/InputTextArea';
import TestimonialPanel from '../components/Panel/TestimonialPanel';
import Testimonial from '../components/Testimonial/Testimonial';
import Submit from '../components/Form/Submit/Submit';
import PageTransition from '../components/pageTransition';

const API_PATH =
  'http://dev.danielhodkinson.co.uk/reelnature/api/contact/index.php';

const StyledInputGroup = styled(InputGroup)`
  margin-bottom: 32px;
`;

const StyledContactPage = styled.div`
  max-width: 800px;
  margin: 0 auto;
`;

const StyledHref = styled.a`
  color: #355834;
`;

const StyledContactForm = styled.form`
  margin-bottom: 100px;
`;

const StyledUl = styled.ul`
  margin-bottom: 16px;
`

class ContactPage extends Component {
  state = {
    user: {
      name: '',
      email: '',
      message: '',
    },
    loading: false,
    success: false,
    errors: {},
  };

  onChange = event => {
    const field = event.target.name;
    let user = Object.assign({}, this.state.user);
    user[field] = event.target.value;
    return this.setState({ user, errors: {} });
  };

  verifyForm = () => {
    const { user } = this.state;
    return reduce(
      user,
      (prev, cur, key) => {
        if (!user[key] || !user[key].length) {
          return {
            ...prev,
            [key]: true,
          };
        }
        return prev;
      },
      {}
    );
  };

  handleSubmit = e => {
    e.preventDefault();
    const errors = this.verifyForm();
    if (!isEmpty(errors)) {
      this.setState({
        errors,
      });
      return false;
    }

    this.setState({
      loading: true,
    });
    axios({
      method: 'post',
      url: `${API_PATH}`,
      headers: { 'content-type': 'application/json' },
      data: this.state.user,
    })
      .then(result => {
        this.setState({
          success: result.data.sent,
          loading: false,
        });
      })
      .catch(error => this.setState({ error: error.message, loading: false }));
  };

  render() {
    const { user, errors, loading, success } = this.state;
    return (
      <Layout>
        <SEO title="Contact Us" />
        <PageTransition>
          <Wrapper>
            <Title>Contact Us</Title>
            <Container>
              <StyledContactPage>
                <P strong>
                  Thanks for visiting our website! Please feel free to contact
                  us for further information on planning a shoot in Zambia. It
                  is always best to talk and as such you will find our phone
                  numbers below (WhatsApp too), you are also able to contact us
                  on Skype on tyrone.mckeith.
                </P>
                <StyledUl>
                  <li>+260 974173403</li>
                  <li>+260 976215426</li>
                </StyledUl>
                <P>
                  Alternatively, if you’d prefer then drop us an{' '}
                  <StyledHref href="mailto:info@reel-nature.com">
                    email
                  </StyledHref>
                </P>
                <StyledContactForm onSubmit={this.handleSubmit}>
                  <StyledInputGroup
                    value={user.name}
                    label={'Name'}
                    error={errors.name && 'Name is required'}
                  >
                    <InputText name={'name'} onChange={this.onChange} />
                  </StyledInputGroup>
                  <StyledInputGroup
                    value={user.email}
                    label={'Email'}
                    error={errors.email && 'Email address is required'}
                  >
                    <InputText name={'email'} onChange={this.onChange} />
                  </StyledInputGroup>
                  <StyledInputGroup
                    value={user.message}
                    label={'Message'}
                    error={errors.message && 'A message is required'}
                  >
                    <InputTextArea name={'message'} onChange={this.onChange} />
                  </StyledInputGroup>
                  <Submit loading={loading} success={success}>
                    Submit
                  </Submit>
                </StyledContactForm>
              </StyledContactPage>
            </Container>
            <StaticQuery
              query={graphql`
                query ContactPage {
                  site {
                    siteMetadata {
                      testimonials {
                        content
                        author
                      }
                    }
                  }
                }
              `}
              render={data => (
                <TestimonialPanel>
                  <Testimonial
                    testimonial={data.site.siteMetadata.testimonials[0]}
                  />
                </TestimonialPanel>
              )}
            />
          </Wrapper>
        </PageTransition>
      </Layout>
    );
  }
}

export default ContactPage;
